import { render, staticRenderFns } from "./IdentityTheftReportEditor.vue?vue&type=template&id=61b65de6&"
import script from "./IdentityTheftReportEditor.vue?vue&type=script&lang=js&"
export * from "./IdentityTheftReportEditor.vue?vue&type=script&lang=js&"
import style0 from "./IdentityTheftReportEditor.vue?vue&type=style&index=0&id=61b65de6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports